import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const form = css`
  width: 100%;

  button {
    @media (max-width: ${dimensions.phoneLargeMax}) {
      width: 100%;
    }
  }
`;

export const signInWrapperWidth = css`
  max-width: max-content;
`;

export const buttonStyles = css`
  width: unset;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    width: 100%;
  }
`;
